<template>
  <v-card outlined class="country-selector-card" :loading="loading">
    <template v-if="title">
      <v-card-subtitle v-if="textExists(title)">
        {{ title }}
      </v-card-subtitle>
    </template>
    <template v-if="countries.length > 0">
      <v-card-text v-if="textExists(text)">
        {{ text }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-for="country in countries"
          :key="country"
          @click="selectCountry(country)"
          depressed
          :color="selected === country ? 'primary' : undefined"
        >
          <v-icon v-if="selected === country" left>mdi-earth</v-icon>
          {{ country }}
          <v-icon left v-if="country !== 'default'" @click.stop="confirmDelete(country)">mdi-minus-circle</v-icon>
        </v-btn>
        <!-- <v-btn fab small color="primary" class="mx-2">
            <v-icon>mdi-plus</v-icon>
          </v-btn> -->
      </v-card-actions>
    </template>
    <YesNoDialog
      v-model="modal.delete.display"
      :title="modal.delete.title"
      :text="modal.delete.text"
      @validate="deleteCountry"
    />
  </v-card>
</template>

<script>
  import { textExists } from '../../helpers/helper'
  import YesNoDialog from '../dialogs/YesNoDialog.vue'

  export default {
    name: 'CountriesSelector',
    components: {
      YesNoDialog,
    },
    props: {
      countries: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: null,
      },
      text: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        selected: 'default',
        modal: {
          delete: {
            title: this.$t('partners.details.modal.delete.title'),
            text: '',
            display: false,
            selected: 'default',
          },
        },
      }
    },
    methods: {
      selectCountry(country) {
        this.selected = country
        this.$emit('change', country)
      },
      confirmDelete(country) {
        this.modal.delete.selected = country
        this.modal.delete.text = this.$t('partners.details.modal.delete.text', { country })
      },
      deleteCountry() {
        this.$emit('remove', this.modal.delete.selected)
      },
      textExists,
    },
  }
</script>
